module.exports = __webpack_public_path__ + "static/media/resiliance.c0098253.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/resources/img/enhanced-brand/resiliance.jpg
// module id = 1198
// module chunks = 0